import React, { useState, useEffect } from "react";
import { List, Modal, Select, Input, InputNumber, Row, Col, Divider, Menu, Dropdown, AutoComplete, Spin } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { DownOutlined } from "@ant-design/icons";
import { returnDataArrayObject } from "../../../../utils/arrayHelper";
import { isBlankDisplayName } from "../../../../utils/displayName";
import { DragOutlined, EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import NotFound from "../../../../components/NotFound";
import "./Columns.css";

import SearchIcon from "../../../../assets/icons/search-icon.svg";

const { Option } = Select;
// const { Search } = Input; // replaced by a plain Input in the column search — see there

export default function ResourceFilters(props) {
  const [visible, setVisible] = useState(false);
  const [searchColNameKey, setSearchColNameKey] = useState("");

  const [data, setData] = useState([]);
  const [clickedHideAll, setClickedHideAll] = useState(false);
  const dateFormatOptions = [{ value: "YYYY-MM-DD" }, { value: "YYYY-MM-DD HH:mm" }];

  //console.log("returnDataArrayObject(props.reportDataObject)", props);

  function onChangeCheckBoxVal(field, e) {
    props.updateSelectedFields({
      id: field.id,
      fieldName: field.fieldName,
      checked: e.target.checked,
      dataType: field.dataType,
      format: field.format,
      decimalPoints: field.decimalPoints,
    });
    console.log(`checked = ${e.target.checked}`);
  }

  function handleTypeChange(field, value) {
    if (value === "link") {
      setVisible(true);
    }
    props.updateSelectedFields({
      id: field.id,
      fieldName: field.fieldName,
      checked: field.checked,
      dataType: value,
      format: field.format,
      decimalPoints: value === "float" ? 2 : null,
    });
  }

  function handleDateFormatChange(field, e) {
    console.log("EEE===>>>", e);
    props.updateSelectedFields({
      id: field.id,
      fieldName: field.fieldName,
      checked: field.checked,
      dataType: field.dataType,
      format: e,
      decimalPoints: field.decimalPoints,
    });
  }

  function handleDecimalPointsChange(field, value) {
    props.updateSelectedFields({
      id: field.id,
      fieldName: field.fieldName,
      checked: field.checked,
      dataType: field.dataType,
      format: field.format,
      decimalPoints: value,
    });
  }

  const setDisplayNameFieldVisibility = (selectedIndex, isChecked) => {
    const displayValues = data.find((displayValue, index) => index === selectedIndex);
    const field = {
      ...displayValues,
      isDisplayNameVisible: isChecked,
      fieldDisplayName: isChecked && displayValues.fieldDisplayName ? displayValues.fieldDisplayName : null,
    };
    props.updateSelectedFields(field);
  };

  const handleDisplayNameChange = (field, displayName) => {
    props.updateSelectedFields({
      ...field,
      fieldDisplayName: displayName,
    });
  };

  const reportDataFields =
    returnDataArrayObject(props.reportDataObject) && returnDataArrayObject(props.reportDataObject).data[0]
      ? returnDataArrayObject(props.reportDataObject).data[0]
      : null;

  const reorder = (list, startIndex, endIndex) => {
    console.log("list", list);
    console.log("startIndex", startIndex);
    console.log("endIndex", endIndex);

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onHandleMoveTop = (fields) => {
    const categories = reorder(
      props.availableFields,
      props.availableFields?.findIndex((x) => x.id === fields.id),
      0,
    );
    props.reOrderFields(categories);
    setData(categories);
  };

  const onHandleMoveBottom = (fields) => {
    const categories = reorder(
      props.availableFields,
      props.availableFields?.findIndex((x) => x.id === fields.id),
      props.availableFields.length - 1,
    );
    props.reOrderFields(categories);
    setData(categories);
  };

  function onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const categories = reorder(data, result.source.index, result.destination.index);
    props.reOrderFields(categories);
    setData(categories);
  }

  useEffect(() => {
    if (props.availableFields) {
      setData(
        // fieldName can be missing on a malformed/computed entry — String() keeps the
        // whole panel from throwing on one bad field.
        props.availableFields?.filter((item) =>
          String(item?.fieldName ?? "")
            .toLowerCase()
            .includes(searchColNameKey.toLowerCase()),
        ),
      );
    }
  }, [props.availableFields]);

  const onSearchColName = (value) => {
    console.log("Search Value ===>>", value);
    if (value) {
      let FilteredData = (props.availableFields || []).filter((item) =>
        String(item?.fieldName ?? "")
          .toLowerCase()
          .includes(value.toLowerCase()),
      );
      setData((state) => [...FilteredData]);
    } else {
      setData(props.availableFields);
    }
  };

  const onChangeCheckAll = (e) => {
    console.log("Check All ===>>", e);
    setClickedHideAll(!clickedHideAll);
    if (data && reportDataFields) {
      props.availableFields.forEach((field, index) => {
        props.updateSelectedFields({
          id: field.id,
          fieldName: field.fieldName,
          checked: clickedHideAll,
          dataType: field.dataType,
          format: field.format,
          decimalPoints: field.decimalPoints,
        });
      });
    }
  };

  const searchColNameByKey = (e) => {
    setSearchColNameKey(e.target.value);
    // if (e.key === 'Enter') {
    onSearchColName(e.target.value);
    // }
  };

  if (props.reportDataStatus === "pending") {
    return (
      <div style={{ padding: "48px 24px", display: "flex", justifyContent: "center" }}>
        <Spin />
      </div>
    );
  }

  // return (
  //   <div style={{ padding: "8px" }}>
  //     <Modal
  //       title="URL prefix"
  //       centered
  //       visible={visible}
  //       onOk={() => setVisible(false)}
  //       onCancel={() => setVisible(false)}
  //     >
  //       <p>Enter the URL prefix</p>
  //       <Input placeholder="URL prefix" />
  //     </Modal>

  //     <div style={{ borderBottom: "1px solid #eee", paddingBottom: "12px" }}>{/* Columns */}</div>

  //     <div
  //       style={{
  //         borderBottom: "1px solid #eee",
  //         padding: "4px",
  //         background: "#fff",
  //       }}
  //     >
  //       <Row gutter={[16, 16]}>
  //         <Col span={1}></Col>
  //         <Col span={4}>
  //           <label class="check-text">
  //             <input type="checkbox" checked={clickedHideAll} onChange={(e) => onChangeCheckAll(e)} />
  //             <EyeOutlined className="unchecked" />
  //             <EyeInvisibleOutlined className="checked" />
  //           </label>
  //         </Col>
  //         <Col span={17}>
  //           <div>
  //             <Search
  //               placeholder="input search text"
  //               value={searchColNameKey}
  //               onChange={searchColNameByKey}
  //               onSearch={onSearchColName}
  //               style={{ width: "100%" }}
  //             />
  //           </div>
  //         </Col>
  //       </Row>
  //     </div>

  //     {data && reportDataFields ? (
  //       <DragDropContext onDragEnd={onDragEnd}>
  //         <Droppable droppableId="list">
  //           {(provided) => (
  //             <div ref={provided.innerRef} {...provided.droppableProps} style={{ overflowY: "auto", height: "30vh" }}>
  //               {data.map((fields, index) => (
  //                 <Draggable draggableId={fields.id.toString()} index={index} key={fields.id}>
  //                   {(provided) => (
  //                     <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
  //                       <List.Item
  //                         className="draggable raggable-item"
  //                         style={{
  //                           margin: "0 0 .5rem",
  //                           display: "flex",
  //                           flexDirection: "column",
  //                           justifyContent: "space-around",
  //                         }}
  //                       >
  //                         <Row
  //                           style={{
  //                             display: "flex",
  //                             justifyContent: "center",
  //                             alignItems: "center",
  //                             width: "100%",
  //                           }}
  //                         >
  //                           <label class="check-text">
  //                             <input
  //                               type="checkbox"
  //                               checked={fields.checked}
  //                               onChange={(e) => onChangeCheckBoxVal(fields, e)}
  //                             />
  //                             <EyeInvisibleOutlined className="unchecked" />
  //                             <EyeOutlined className="checked" />
  //                           </label>
  //                           <DragOutlined className="icon" />
  //                           <List.Item.Meta title={fields.fieldName} className="grabbable" />
  //                           <Dropdown
  //                             overlayStyle={{ cursor: "pointer" }}
  //                             overlay={
  //                               <Menu>
  //                                 <Menu.Item key="0" onClick={() => onHandleMoveTop(fields)}>
  //                                   Move to top
  //                                 </Menu.Item>
  //                                 <Menu.Divider />
  //                                 <Menu.Item key="1" onClick={() => onHandleMoveBottom(fields)}>
  //                                   Move to bottom
  //                                 </Menu.Item>
  //                                 <Menu.Divider />
  //                                 <Menu.Item key="1">
  //                                   <input
  //                                     type="checkbox"
  //                                     checked={fields.isDisplayNameVisible}
  //                                     onChange={(e) => setDisplayNameFieldVisibility(index, e.target.checked)}
  //                                   />
  //                                   Set display name
  //                                 </Menu.Item>
  //                               </Menu>
  //                             }
  //                             trigger={["click"]}
  //                           >
  //                             <span
  //                               className="ant-dropdown-link"
  //                               onClick={(e) => e.preventDefault()}
  //                               style={{ marginRight: "5px" }}
  //                             >
  //                               <DownOutlined style={{ cursor: "pointer" }} />
  //                             </span>
  //                           </Dropdown>
  //                         </Row>
  //                         <Row style={{ width: "100%" }}>
  //                           <Select
  //                             defaultValue={
  //                               fields.dataType ? fields.dataType : typeof reportDataFields[fields.fieldName]
  //                             }
  //                             onChange={(val) => handleTypeChange(fields, val)}
  //                             size="small"
  //                             style={{ width: "100%" }}
  //                           >
  //                             <Option key="daf_opt_1" value="number">
  //                               Number
  //                             </Option>
  //                             <Option key="daf_opt_2" value="float">
  //                               Float
  //                             </Option>
  //                             <Option key="daf_opt_3" value="int">
  //                               Integer
  //                             </Option>
  //                             <Option key="daf_opt_4" value="string">
  //                               String
  //                             </Option>
  //                             <Option key="daf_opt_5" value="link">
  //                               Link
  //                             </Option>
  //                             <Option key="daf_opt_6" value="link">
  //                               Link
  //                             </Option>
  //                             <Option key="daf_opt_7" value="date">
  //                               Date
  //                             </Option>
  //                             <Option key="daf_opt_8" value="boolean">
  //                               Boolean
  //                             </Option>
  //                             <Option key="daf_opt_9" value="object">
  //                               Object
  //                             </Option>
  //                             <Option key="daf_opt_10" value="array">
  //                               Array
  //                             </Option>
  //                             <Option key="daf_opt_11" value="null">
  //                               NULL
  //                             </Option>
  //                             <Option key="daf_opt_12" value="undefined">
  //                               Undefined
  //                             </Option>
  //                           </Select>
  //                         </Row>
  //                         {fields.dataType === "date" ? (
  //                           <Row>
  //                             <AutoComplete
  //                               // value={dateFormat}
  //                               style={{ width: "100%" }}
  //                               placeholder="Date Format"
  //                               options={dateFormatOptions}
  //                               onChange={(e) => handleDateFormatChange(fields, e)}
  //                               value={fields.format}
  //                             />
  //                           </Row>
  //                         ) : null}
  //                         {fields.dataType === "float" ? (
  //                           <Row>
  //                             <Select
  //                               defaultValue={2}
  //                               onChange={(val) => handleDecimalPointsChange(fields, val)}
  //                               size="small"
  //                               style={{ width: "100%" }}
  //                             >
  //                               <Option key="dec_opt_1" value={1}>
  //                                 1
  //                               </Option>
  //                               <Option key="dec_opt_2" value={2}>
  //                                 2
  //                               </Option>
  //                               <Option key="dec_opt_3" value={3}>
  //                                 3
  //                               </Option>
  //                               <Option key="dec_opt_4" value={4}>
  //                                 4
  //                               </Option>
  //                               <Option key="dec_opt_5" value={5}>
  //                                 5
  //                               </Option>
  //                               <Option key="dec_opt_6" value={6}>
  //                                 6
  //                               </Option>
  //                             </Select>
  //                           </Row>
  //                         ) : null}
  //                         {fields.isDisplayNameVisible && (
  //                           <Row>
  //                             <Input
  //                               placeholder="Display name"
  //                               onChange={(e) => handleDisplayNameChange(fields, e.target.value)}
  //                               value={fields.fieldDisplayName}
  //                             />
  //                           </Row>
  //                         )}
  //                       </List.Item>
  //                     </div>
  //                   )}
  //                 </Draggable>
  //               ))}
  //               {provided.placeholder}
  //             </div>
  //           )}
  //         </Droppable>
  //       </DragDropContext>
  //     ) : (
  //       <div>
  //         <NotFound />
  //       </div>
  //     )}
  //   </div>
  // );

  // Columns come from the saved config (availableFields). Live data is only needed to
  // guess a type for a field that has none saved — it must not gate the whole list,
  // or editing a report whose API is momentarily down showed an empty panel.
  const hasColumns = Boolean(data && data.length);
  const hasLiveData = Boolean(reportDataFields);
  const guessType = (fields) => {
    if (fields.dataType) return fields.dataType;
    if (hasLiveData && reportDataFields[fields.fieldName] !== undefined) {
      return typeof reportDataFields[fields.fieldName];
    }
    return "string";
  };

  return (
    <div className="columns-wrapper">
      <Modal
        title="URL prefix"
        centered
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
      >
        <p>Enter the URL prefix</p>
        <Input placeholder="URL prefix" />
      </Modal>

      {/* HEADER */}

      {/* SEARCH */}
      <div className="columns-search">
        {/* <Search
          className="columns-search-input"
          placeholder="Search columns..."
          value={searchColNameKey}
          onChange={searchColNameByKey}
          onSearch={onSearchColName}
        /> */}
        {/* A plain Input: antd's Search draws its own magnifier button, which sat next to
            the icon below — two search icons. Typing already filters (onChange), so the
            button added nothing; Enter still searches. allowClear keeps the styled affix
            wrapper (.columns-search .ant-input-affix-wrapper) and adds a clear ✕. */}
        <Input
          className="columns-search-input"
          placeholder="Search columns..."
          value={searchColNameKey}
          onChange={searchColNameByKey}
          onPressEnter={(e) => onSearchColName(e.target.value)}
          allowClear
        />
        <div className="search-icon-wrapper">
          <img src={SearchIcon} alt="search-icon" />
        </div>
      </div>

      {/* Saved columns are shown, but without a sample row we cannot detect types. */}
      {hasColumns && !hasLiveData ? (
        <div className="columns-notice">
          Showing your saved columns. This resource returned no data, so column types could not be detected — use
          Refresh once the data is available.
        </div>
      ) : null}

      {/* LIST */}

      {hasColumns ? (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="list">
            {(provided) => (
              <div className="columns-list" ref={provided.innerRef} {...provided.droppableProps}>
                {data.map((fields, index) => (
                  <Draggable
                    draggableId={String(fields.id ?? `col_${index}`)}
                    index={index}
                    key={fields.id ?? `col_${index}`}
                  >
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        <List.Item className="column-card">
                          {/* TOP */}
                          <div className="column-card-top" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <h4 className="column-name" style={{ flex: 1 }}>
                              {fields.fieldName}
                            </h4>
                            {/* flex row, so the box and its label share a centre line -
                                inline elements align on the text baseline instead */}
                            <label className="column-visibility-toggle">
                              <input
                                type="checkbox"
                                checked={fields.checked}
                                onChange={(e) => onChangeCheckBoxVal(fields, e)}
                              />
                              {fields.checked ? "Hide" : "Unhide"}
                            </label>
                            <Dropdown
                              overlayStyle={{ cursor: "pointer" }}
                              overlay={
                                <Menu>
                                  <Menu.Item key="0" onClick={() => onHandleMoveTop(fields)}>
                                    Move to top
                                  </Menu.Item>
                                  <Menu.Divider />
                                  <Menu.Item key="1" onClick={() => onHandleMoveBottom(fields)}>
                                    Move to bottom
                                  </Menu.Item>
                                  <Menu.Divider />

                                  <Menu.Divider />
                                  <Menu.Item key="3">
                                    <input
                                      type="checkbox"
                                      checked={fields.isDisplayNameVisible}
                                      onChange={(e) => setDisplayNameFieldVisibility(index, e.target.checked)}
                                    />
                                    &nbsp; Set display name
                                  </Menu.Item>
                                </Menu>
                              }
                              trigger={["click"]}
                            >
                              <span className="column-menu" onClick={(e) => e.preventDefault()}>
                                ⋮
                              </span>
                            </Dropdown>
                          </div>

                          {/* DISPLAY NAME + TYPE */}
                          <div className="column-config-row">
                            <span className="column-label">Display Name</span>

                            {/* <Input
                              className="column-display-input"
                              value={fields.fieldDisplayName || fields.fieldName}
                              onChange={(e) => handleDisplayNameChange(fields, e.target.value)}
                            /> */}
                            {/* `??`, not `||`: "" is a cleared name, not an unset one. With
                                `||` the box refilled with the column name the moment the
                                last character was deleted, so it could never be emptied.
                                Unset (null/undefined) still shows the column's own name.
                                A cleared name is required — red, with a message — and the
                                editor holds Save/Publish until it is filled. */}
                            {(() => {
                              const isEmpty = isBlankDisplayName(fields.fieldDisplayName);
                              return (
                                <div className="column-display-field">
                                  <Input
                                    className={`column-display-input${isEmpty ? " has-error" : ""}`}
                                    value={fields.fieldDisplayName ?? fields.fieldName}
                                    onChange={(e) => handleDisplayNameChange(fields, e.target.value)}
                                  />
                                  {isEmpty && <div className="column-display-error">This field is required</div>}
                                </div>
                              );
                            })()}

                            <Select
                              className="column-type-select"
                              value={guessType(fields)}
                              onChange={(val) => handleTypeChange(fields, val)}
                            >
                              <Option value="number">Number</Option>
                              <Option value="float">Float</Option>
                              <Option value="int">Integer</Option>
                              <Option value="string">String</Option>
                              <Option value="link">Link</Option>
                              <Option value="date">Date</Option>
                              <Option value="boolean">Boolean</Option>
                              <Option value="object">Object</Option>
                              <Option value="array">Array</Option>
                              <Option value="null">NULL</Option>
                              <Option value="undefined">Undefined</Option>
                            </Select>
                          </div>

                          {/* DATE FORMAT */}
                          {fields.dataType === "date" && (
                            <div style={{ marginTop: 12 }}>
                              <AutoComplete
                                className="column-date-format"
                                style={{ width: "100%" }}
                                placeholder="Date Format"
                                options={dateFormatOptions}
                                onChange={(e) => handleDateFormatChange(fields, e)}
                                value={fields.format}
                              />
                            </div>
                          )}

                          {/* FLOAT */}
                          {fields.dataType === "float" && (
                            <div style={{ marginTop: 12 }}>
                              <Select
                                className="column-float-select"
                                defaultValue={2}
                                onChange={(val) => handleDecimalPointsChange(fields, val)}
                                style={{ width: "100%" }}
                              >
                                <Option value={1}>1</Option>
                                <Option value={2}>2</Option>
                                <Option value={3}>3</Option>
                                <Option value={4}>4</Option>
                                <Option value={5}>5</Option>
                                <Option value={6}>6</Option>
                              </Select>
                            </div>
                          )}
                        </List.Item>
                      </div>
                    )}
                  </Draggable>
                ))}

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      ) : (
        // Columns are generated from the resource's own response — there is no schema
        // to fall back on — so say that plainly instead of an unexplained empty panel.
        <div className="columns-empty">
          <NotFound />
          <h4 className="columns-empty-title">No columns to show</h4>
          <p className="columns-empty-text">
            Columns are generated from the data this resource returns. Nothing came back from it, so there is nothing to
            configure yet.
          </p>
          <p className="columns-empty-hint">
            Check that the resource returns rows, then use Refresh in the toolbar.
          </p>
        </div>
      )}
    </div>
  );
}
